import { render, staticRenderFns } from "./ProfileSettingsLayout.vue?vue&type=template&id=7b6303f5"
import script from "./ProfileSettingsLayout.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports